import { render, staticRenderFns } from "./BlockCard.vue?vue&type=template&id=721c8fe0&scoped=true"
import script from "./BlockCard.vue?vue&type=script&lang=js"
export * from "./BlockCard.vue?vue&type=script&lang=js"
import style0 from "./BlockCard.vue?vue&type=style&index=0&id=721c8fe0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721c8fe0",
  null
  
)

export default component.exports